export default __webpack_public_path__ + "static/media/vip-bg.701b1dff.webp";